import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './LandscapeProjectsAddProjectsAddContactPersonTemplate.module.css';
import cn from 'classnames';
import { Label } from '../../atoms';
import { Button, Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomDropdown } from '../../molecules';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';
import { DropdownItem } from '../../molecules/CustomDropdown/CustomDropdown';

export interface LandscapeProjectsAddProjectsAddContactPersonTemplateProps {
  buyers: BuyerResponseDto[];
  setSelectedBuyer: React.Dispatch<React.SetStateAction<BuyerResponseDto>>;
  handleOnSubmit: () => void;
}

const LandscapeProjectsAddProjectsAddContactPersonTemplate: FC<
  LandscapeProjectsAddProjectsAddContactPersonTemplateProps
> = ({ buyers, setSelectedBuyer, handleOnSubmit }) => {
  const buyerItems: DropdownItem[] = buyers.map((buyer) => {
    return {
      label: buyer.name ?? 'Name not found',
      eventKey: buyer.id,
    };
  });

  const navigate = useNavigate();

  const { id, projectId } = useParams();

  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Choose Supporter" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/projects/add-project/${projectId}/general-information`
              )
            }
            variant="link"
          >
            Go back to overview
          </Button>
        </div>
        <CustomDropdown
          items={buyerItems}
          initialTitle={'Please select supporter...'}
          onSelectOption={(item: DropdownItem) => {
            const selectedBuyer = buyers.find(
              (buyer) => buyer.id === item.eventKey
            )!;
            setSelectedBuyer(selectedBuyer);
          }}
        ></CustomDropdown>
        <Button
          onClick={handleOnSubmit}
          className={cn(styles.button)}
          variant="dark"
        >
          Save
        </Button>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectsAddProjectsAddContactPersonTemplate;
